import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { addUsersFromCsv } from '../../../api/users';

const useAddUserFromCsv = (options?: Omit<UseMutationOptions, 'mutationFn'>) => {
  return useMutation({
    mutationFn: addUsersFromCsv,
    ...options,
  });
};

export default useAddUserFromCsv;
